module.exports = __webpack_public_path__ + "img/1-4.05cb19a0.svg";